import { Icon, Space, Button, Title } from '@bb/elements-web';
import styled from 'styled-components';
import React from 'react';
import { StyledCard, StyledText } from './styledComponents';

export default function SingleAccessSuccessCard() {
  return (
    <StyledCard $bordered={false}>
      <Space size={24} direction="vertical">
        <IconWrapper>
          <Icon icon="checkOutlined" color="primary" size={24} />
        </IconWrapper>
        <Space size={8} direction="vertical" align="center">
          <Title
            dataCy="single-access-success-title"
            level={4}
            textAlign="center"
            margin={0}
          >
            Check your inbox!
          </Title>
          <StyledText size="large" $secondary $alignCenter>
            Click the link in your email to activate your account and get
            started.
          </StyledText>
        </Space>

        <Space size={8} direction="vertical" align="center">
          <StyledText size="large" $secondary $alignCenter>
            It may take a few minutes to send the email. Check your junk folder.
          </StyledText>
          {/* TODO KB-1362 this should resend the email invite */}
          {false && (
            <Button dataCy="single-access-resent-invitation-button">
              Resend Invitation
            </Button>
          )}
        </Space>
      </Space>
    </StyledCard>
  );
}

const IconWrapper = styled.div`
  background-color: #f0f7ff;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
